import zoomSdk from '@zoom/appssdk'

export default async function configureZoomApp () {
  await zoomSdk.config({
    popoutSize: { width: 480, height: 960 },
    capabilities: [
      'shareApp',
      'onMyUserContextChange',
      'getMeetingUUID',
      'getUserContext',
      'openUrl',
      'connect',
      'sendMessage'
    ]
  })

  try {
    const zoomUserContext = await zoomSdk.getUserContext()
    if (zoomUserContext.role === 'host') {
      await sendMessageToZoomParticipants()
    }
  } catch (error) {
    window.Rollbar?.error('Failed to connect to Zoom: ', error)
  }
}

const sendMessageToZoomParticipants = async () => {
  try {
    const connectToZoom = await zoomSdk.connect()
    if (connectToZoom.message === 'Success') {
      await zoomSdk.sendMessage({ payload: { message: 'refresh' } })
    }
  } catch (error) {
    window.Rollbar?.error('Failed sending message to Zoom participants: ', error)
  }
}
